export default __webpack_public_path__ + "static/media/ye.de26b313.svg";